import { useEffect, useState } from "react";
import type { IndicatorSeries } from "../types";
import { dailyAnalysisClient } from "../data/dailyAnalysisClient";
import { DAILY_ANALYSIS_ENABLED } from "../data/dailyAnalysisConfig";
import HousingMarketTechnicalChartView from "./HousingMarketTechnicalChartView";
import HousingMarketTapePanel from "./HousingMarketTapePanel";

type HousingHtsMode = "hts" | "tape";

export default function HousingMarketTechnicalChart({ officialHousingPrices = [] }: { officialHousingPrices?: IndicatorSeries[] }) {
  const [mode, setMode] = useState<HousingHtsMode>("hts");
  const [update, setUpdate] = useState<{ latestGenerationId: string; latestComputedAt: string } | null>(null);
  const [repinning, setRepinning] = useState(false);

  useEffect(() => {
    if (!DAILY_ANALYSIS_ENABLED) return;
    let disposed = false;
    const check = async () => {
      try {
        const status = await dailyAnalysisClient.updateStatus();
        if (!disposed) setUpdate(status.updateAvailable ? { latestGenerationId: status.latestGenerationId, latestComputedAt: status.latestComputedAt } : null);
      } catch { /* current internally consistent generation remains valid; update discovery is best-effort */ }
    };
    const first = window.setTimeout(check, 60_000);
    const interval = window.setInterval(check, 5 * 60_000);
    return () => { disposed = true; window.clearTimeout(first); window.clearInterval(interval); };
  }, []);

  return <>
    {update && <div className="housing-hts-update-banner" role="status">
      <span>새 일일 분석 세대가 있습니다 · {new Date(update.latestComputedAt).toLocaleString("ko-KR", { timeZone: "Asia/Seoul" })} KST</span>
      <button type="button" disabled={repinning} onClick={async () => {
        if (repinning) return;
        setRepinning(true);
        try { await dailyAnalysisClient.repin(); window.location.reload(); }
        catch { setRepinning(false); }
      }}>{repinning ? "갱신 중…" : "새 세대로 갱신"}</button>
    </div>}
    <div className="housing-hts-mode-switch" role="group" aria-label="주택 HTS 보기 방식">
      <button type="button" className={mode === "hts" ? "is-active" : ""} onClick={() => setMode("hts")}>HTS</button>
      <button type="button" className={mode === "tape" ? "is-active" : ""} onClick={() => setMode("tape")}>실거래 Tape</button>
    </div>
    {mode === "hts"
      ? <HousingMarketTechnicalChartView officialHousingPrices={officialHousingPrices} />
      : <HousingMarketTapePanel />}
  </>;
}
